var React = require('react');

function FreezoneCornerLeftArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M-1.08243e-05 212.068C41.0585 171.01 245.358 -33.3577 380 -168L380 -137.545L30.5713 211.883L380 561.312L380 591.767L-1.08243e-05 212.068Z","fill":"#CE445B","key":0}),React.createElement("path",{"d":"M25.6461 212.068C66.7046 171.01 245.358 -2.90295 380 -137.545V-107.09L56.2174 211.883L380 530.857L380 561.312L25.6461 212.068Z","fill":"#CE445B","key":1})]);
}

FreezoneCornerLeftArrow.defaultProps = {"width":"251","height":"425","viewBox":"0 0 251 425","fill":"none"};

module.exports = FreezoneCornerLeftArrow;

FreezoneCornerLeftArrow.default = FreezoneCornerLeftArrow;
